import React, { ChangeEvent } from 'react';

import css from './RadioButtonGroup.module.scss';

interface Props {
  radioButtons: RadioButton[];
  selected?: string;
  onClick?: () => void;
  onChange?: (value: ChangeEvent<HTMLInputElement>) => void;
}

interface RadioButton {
  value: string;
  label: string;
  id?: string;
  onChange?: (value: ChangeEvent<HTMLInputElement>) => void;
  'data-e2e'?: string;
}

const RadioButtonGroup = ({
  radioButtons,
  selected,
  onClick,
  onChange
}: Props) => (
  <div className={css.radioButtonGroup}>
    {radioButtons.map(radioButton => {
      const { value, id, label } = radioButton;
      return (
        <div className={css.radioButtonGroupItem} key={value}>
          <input
            id={id || value}
            className={`${css.radioButtonInput}`}
            type="radio"
            value={value}
            onClick={onClick}
            checked={selected === value}
            onChange={radioButton.onChange || onChange}
            data-e2e={radioButton['data-e2e']}
          />
          <label htmlFor={id || value}>{label}</label>
        </div>
      );
    })}
  </div>
);

export default RadioButtonGroup;
